import { render, staticRenderFns } from "./MooMooFarm.vue?vue&type=template&id=00d5b900"
import script from "./MooMooFarm.vue?vue&type=script&lang=js"
export * from "./MooMooFarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports